import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dc, {d3, crossfilter} from 'dc';
import * as chartsUtilFunctions from './util/chartsUtilFunctions';
import * as utilFunctions from './util/utilFunctions';
import BaseChart from './baseChart';
import MapWrapper from './util/mapWrapper';
import CircularProgress from 'material-ui/CircularProgress';
import CheckCircle from '../../../../../../public/images/checkBig.png';

class MapTravelChart extends BaseChart {
  constructor(props, context) {
    super(props, context);
    this.state = utilFunctions.mergeState(this.state, {
      config: utilFunctions.mergeState(this.state.config, {
          eventsCol: {
            type:null,
            path: null
          },  
          showLegend: true,
        }),
      labels:[],
      chartData: null,
      direction: null,
      directionLoading: false,
      events: [],
      firstLoad:true
    });  
    this.state.extraClass = "mapChart";
    this.setData = this.setData.bind(this);
  }

  getChartTypeInstance() {
    return null;
  }

  stylingAndFormat() {}
  postRenderOperations() {}
  preRenderOperations() {}
  setSize() {}

  initializeBasicChartConfig() {
    this.state.config = chartsUtilFunctions.setConfigParams(this.props.config, this.state.config);
    this.state.chart = this.getChartTypeInstance();  

    this.setMetrics();
  }

  setData(props = this.props) {
    var metrics = this.state.crossfilter.getMetrics();
    this.state.direction = props.direction;
    this.state.directionLoading = props.directionLoading;
    this.state.labels = props.dimension.reduceFunction.parameters.labels;
    this.state.events = this.state.crossfilter.getDim().top(Infinity);
    this.state.chartData = metrics[0].all();
    this.state.chart = true;
  }

  setMetrics() {    
    this.setData();
  }

  handleResize() {
    d3.select(this.refs.containerDivDom).classed("showComponent",true);
    this.setData();
  }

  renderOrRedraw() {
    if(this.state.chart==null) {
      this.makeChart();      
      d3.select(this.refs.containerDivDom).classed("showComponent",true);
    }    
  }

  componentDidMount() {
    super.componentDidMount();
    
    if(this.props.noLoading==true) {
      this.setState({
        firstLoad:true
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) { 
    if(this.props.directionLoading != nextProps.directionLoading
      || this.state.chart == null 
      || (nextState.firstLoad==true && this.props.noLoading==true)) {
      if(this.state.chart != null) {
        this.setData(nextProps);
      }
      this.state.firstLoad=false;
      return true;
    }
    return false;
  }

  render() {
    var chart = null;
    var eventsIcons=[];
    var eventPolylines=[];
    var legendItems = [];
    if(this.state.direction != null && this.state.directionLoading==false) {  
      var categoriesArray = this.props.dimension.reduceFunction.parameters.categories;
      var categoriesParser = this.props.dimension.reduceFunction.parameters.categoriesParser;
      var labels = this.props.dimension.reduceFunction.parameters.labels;
      var eventsCount = {};
      for(var i = 0; i<labels.length; i++) {
        eventsCount[labels[i]] = 0;
      }
      var isInRangeFunction = chartsUtilFunctions.isInRange;
      var routePath = this.state.direction.points; 
      var events = this.state.events;

      if("events" in this.state.direction) {
        events = this.state.direction.events;
      }

      for(var i=0;i<events.length;i++) {
        var eventColor="#ccc"; 
        var path = events[i][this.state.config.eventsCol.path];

        for(var j=0;j<categoriesArray.length;j++) {  
          if(isInRangeFunction(categoriesArray[j],events[i][this.state.config.eventsCol.type],[],categoriesParser)) {
            eventColor = this.state.config.colors[j];
            eventsCount[labels[j]]++;
          }
        }

        if(path.length>1) {
          var eventStartPoint = path[0];
          var eventEndPoint = path[path.length-1];
          var endState = false;
          var eventPath = [];

          for(var j=0;j<routePath.length-1;j++) {
            var distanceToStartPoint = utilFunctions.computeDistanceBetween(eventStartPoint, routePath[j]);;
            var distanceToEndPoint = utilFunctions.computeDistanceBetween(eventEndPoint, routePath[j]);;
            var routePointsDistance = utilFunctions.computeDistanceBetween(routePath[j], routePath[j+1]);

            if(distanceToStartPoint<=1 && distanceToEndPoint<=1) {
              eventPath = [];
              eventPath.push(routePath[j]);
              eventPath.push(routePath[j+1]);
              endState = true;
            }
            else if(distanceToStartPoint<=10) {
              eventPath = [];
              eventPath.push(routePath[j]);              
            }
            else if(distanceToEndPoint<=10){
              eventPath.push(routePath[j]);
              endState = true;
            }
            else if(eventPath.length>0) {
              eventPath.push(routePath[j]);
            }

            if(endState == true) {
              break;
            }
          }
          if(!endState) {
            eventsIcons[eventsIcons.length] = {
              point:path[0],
              color:eventColor
            };
          }
          else {
            eventPolylines[eventPolylines.length] = {path:eventPath,color:eventColor};
          }          
        }
        else if(path.length==1) {
          eventsIcons[eventsIcons.length] = {
            point:path[0],
            color:eventColor
          };
        }
      }

      for(var i=0;i<this.state.chartData.length;i++) {
        var result = this.state.chartData[i];
        var label = result.key;
        var color = this.state.config.colors[i];
        var value;
        if("events" in this.state.direction) {
            value = eventsCount[label];
        }
        else {
            value = (this.state.crossfilter.getValueAccesor())(result);
        }
        var legendCircle = (<div style={{backgroundColor:color}} className="legendCount"><span>{value}</span></div>);
        if(value == 0) {
          legendCircle = (<img src={CheckCircle} className="legendCount"/>);
        }
        legendItems[i] = (<div key={i} className="legendItem">{legendCircle}<span>{label}</span></div>);
      }

      chart = (
        <MapWrapper
          routePath={routePath}
          eventPolylines={eventPolylines}
          eventsIcons={eventsIcons}
        />
      );
    }
    else if(this.state.direction == null && this.state.directionLoading==true) {
      chart = (<CircularProgress color={"#DE7200"} className="pageLoading" size={120}/>);
    }
    else {
      chart = (<div><span>{"Mapa no disponible"}</span></div>);
    }

    var noMapLegendClass = "";
    if("showLegend" in this.props.config && this.props.config.showLegend==false) {
      noMapLegendClass = " noMapLegend";
    }

    return (
      <div 
        className={"animateOnLoad autoResizeComponent " + this.state.extraClass + noMapLegendClass} 
        ref="containerDivDom"
        id={this.props.id}>
        <div className="chartWrapper">
          <table><tbody><tr><td>{chart}</td></tr></tbody></table>
        </div>
        <div className="mapLegend">
          {legendItems}          
        </div>
      </div>
    );
  }
}


export default MapTravelChart;


// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/mapTravelChart.jsx